import { render, staticRenderFns } from "./RevisionCreate.vue?vue&type=template&id=05db5c7e&scoped=true"
import script from "./RevisionCreate.vue?vue&type=script&lang=js"
export * from "./RevisionCreate.vue?vue&type=script&lang=js"
import style0 from "./RevisionCreate.vue?vue&type=style&index=0&id=05db5c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05db5c7e",
  null
  
)

export default component.exports